import React, { Fragment } from 'react';
import { Container, Row, Col, Input } from 'reactstrap';
import { NavLink, Switch } from "react-router-dom";
import "./Nav.css";
import Companies from '../../pages/Companies';
import Client from '../../pages/Client';
import Users from '../../pages/Users';
import Forms from '../../pages/Forms';
import ProtectedRoute from "../../auth/protected-route";
import AuthenticationButton from "../AuthenticationButton/AuthenticationButton";
import PermissionWrapper from '../../auth/PermissionWrapper';
import Reports from '../../pages/Reports';

class Nav extends React.Component {
    constructor(props) {
        super(props);

        this.links = [
            { url: "/company", link: "Forms", authenticated: true, align: 'left', multiClient: false },
            { url: "/reports", link: "Reports", permission: "View Reports", authenticated: true, align: 'left', multiClient: false },
            { url: "/users", link: "User Admin", permission: "Admin Access", authenticated: true, align: 'right' },
            { url: "/forms", link: "Form Admin", permission: "Form Admin", authenticated: true, align: 'right' },
            // { url: "/companies", link: "Company Admin", permission: "Admin Access", authenticated: true, align: 'right' },
        ]

    }

    checkPermission = (permission) => {
        this.props.info('Nav.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    render() {
        console.log(this.props.auth0user[process.env.REACT_APP_NAMESPACE+'app_metadata'])
        return (
            <>
                <nav className="Nav">
                    <Container fluid >
                        <Row className='navContainer'>

                            {/* {userClientsEnabled ? */}
                            <Col md={3} className="px-2">
                                <Input type="select" className="" name="clientId" value={this.props.clientId} onChange={(e) => this.props.onChangeClient(e.target.value, () => {
                                    window.location.reload();
                                })}>
                                    {this.props.auth0user[process.env.REACT_APP_NAMESPACE+'app_metadata']?.companies.map(company => (
                                        <option key={company.company} value={"PPE_"+company.company}>{company.company}</option>
                                    ))}
                                    {/* <option value="PPE_Dworman">Dworman</option>
                                    <option value="PPE_CSSI_Test">CSSI Test</option> */}
                                </Input>
                            </Col>
                            {/* : <Col md={3}></Col>} */}
                            <Col md={3} className="text-left">
                                {this.links.filter(link => link.align === 'left').map(link => {
                                    if ((link.authenticated && this.props.isAuthenticated) || link.authenticated == null) {
                                        if ((link.permission != null && this.checkPermission(link.permission)) || link.permission == null) {
                                            // if (client != null) {
                                            return (
                                                <NavLink key={link.url}
                                                    activeClassName="navbar__link--active"
                                                    className="navbar__link"
                                                    to={(link.multiClient) ? this.props.replaceSpecialChars('/' +
                                                        // client.client + 
                                                        link.url)
                                                        : link.url}>{link.link}</NavLink>
                                            )
                                            // } else {
                                            // return (<Fragment key={link.url}></Fragment>)
                                            // }
                                        } else {
                                            return (<Fragment key={link.url}></Fragment>);
                                        }
                                    } else {
                                        return (<Fragment key={link.url}></Fragment>);
                                    }
                                })}
                            </Col>
                            <Col md={6} className="text-right">
                                {this.links.filter(link => link.align === 'right').map(link => {
                                    if ((link.authenticated && this.props.isAuthenticated) || link.authenticated == null) {
                                        if ((link.permission != null && this.checkPermission(link.permission)) || link.permission == null) {
                                            return (
                                                <NavLink key={link.url} exact
                                                    activeClassName="navbar__link--active"
                                                    className="navbar__link"
                                                    to={(link.multiClient) ? this.props.replaceSpecialChars('/' +
                                                        // client.client + 
                                                        link.url)
                                                        : link.url}>{link.link}</NavLink>
                                            )
                                        } else {
                                            return (<Fragment key={link.url}></Fragment>);
                                        }
                                    } else {
                                        return (<Fragment key={link.url}></Fragment>);
                                    }
                                })}
                                <AuthenticationButton />
                            </Col>
                        </Row>
                    </Container>
                </nav>
                <div className="appContent">
                    <Switch>
                        <ProtectedRoute path={"/company"} component={(props) =>
                            <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Modify Forms">
                                <Client {...props} {...this.props} {...this.state} />
                            </PermissionWrapper>} />
                        <ProtectedRoute path={"/reports"} component={(props) =>
                            <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="View Reports">
                                <Reports {...props} {...this.props} {...this.state} />
                            </PermissionWrapper>} />
                        <ProtectedRoute path={"/users"} component={(props) =>
                            <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Admin Access">
                                <Users {...props} {...this.props} {...this.state} />
                            </PermissionWrapper>} />
                        <ProtectedRoute exact path="/forms" component={(props) =>
                            <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Form Admin">
                                <Forms {...props} {...this.props} {...this.state} />
                            </PermissionWrapper>} />
                        <ProtectedRoute exact path="/companies" component={(props) =>
                            <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Admin Access">
                                <Companies {...props} {...this.props} {...this.state} />
                            </PermissionWrapper>} />
                    </Switch>
                </div>
            </>
        )
    }
}

export default Nav;